module.exports = __webpack_public_path__ + "img/step5-mobile-en@2x.9efe4763.webp";